import { render, staticRenderFns } from "./ProfileList.vue?vue&type=template&id=76c81d72"
import script from "./ProfileList.vue?vue&type=script&lang=js"
export * from "./ProfileList.vue?vue&type=script&lang=js"
import style0 from "./ProfileList.vue?vue&type=style&index=0&id=76c81d72&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports